// Ported verbatim from the LeadMailer Design System (components/forms/Checkbox.jsx).
import React from 'react'

export interface CheckboxProps {
  checked?: boolean
  onChange?: (checked: boolean) => void
  label?: React.ReactNode
  disabled?: boolean
  style?: React.CSSProperties
}

export function Checkbox({ checked, onChange, label, disabled, style }: CheckboxProps) {
  const toggle = () => !disabled && onChange && onChange(!checked)
  return (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        fontSize: 'var(--text-base)',
        color: 'var(--text-primary)',
        minHeight: 24,
        ...style,
      }}
    >
      <span
        onClick={toggle}
        style={{
          width: 16,
          height: 16,
          flex: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 4,
          border: `1px solid ${checked ? 'var(--accent)' : 'var(--border-strong)'}`,
          background: checked ? 'var(--accent)' : 'var(--surface-card)',
          transition: 'background var(--dur-fast) var(--ease-out)',
        }}
      >
        {checked && (
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#fff"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        )}
      </span>
      {label && <span onClick={toggle}>{label}</span>}
    </label>
  )
}
